import { render, staticRenderFns } from "./CustomerMatchStatus.vue?vue&type=template&id=3678158e"
import script from "./CustomerMatchStatus.vue?vue&type=script&lang=ts"
export * from "./CustomerMatchStatus.vue?vue&type=script&lang=ts"
import style0 from "./CustomerMatchStatus.vue?vue&type=style&index=0&id=3678158e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports